import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new"
import {
    VALIDATION_CHECKED,
    VALIDATION_LABELS, VALIDATION_UNCHECKED
} from "../../../../../model2/automation/lib/custom-field-validation"
import {FieldAutomationActionFormProps} from "../../../../render/automation-action-form";

const options = [
    {value: true,   label: VALIDATION_LABELS[VALIDATION_CHECKED]},
    {value: false,  label: VALIDATION_LABELS[VALIDATION_UNCHECKED]}
]

const debug = false
// const debug = "CheckboxActionForm"

export default class FieldCheckbox_AutomationActionForm extends React.Component<any,any> {

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationActionFormProps) {
        super(props)

        this.state = {
            toValue: _.get(props.config, 'toValue', null),
        }
    }

    onChangeToValue = (option:any) => {
        const toValue = option.value

        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state, options)

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        return (
            <div className="flex-row-left-top">
                <div className={labelClasses}>to</div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {options}
                                  value                         = {this.state.toValue}
                                  popoverScrollContainerClasses = "max-h-200 max-w-300"
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeToValue}/>
            </div>
        )
    }
}
